import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
  ReactNode,
} from "react";
import { ButtonLink } from "./button/Button";

export const NOOP = () => {};

interface Tab {
  name: string;
  content: ReactNode;
  headerAction?: ReactNode;
  url: string;
  isDisabled?: boolean;
}

interface TabsPanelProps {
  tabs: Tab[];
  baseClassName: string;
  activeTab: string;
  callback: Function;
  scrollToTopEnable?: boolean;
}

interface TabsProps {
  baseClassName: string;
  children: ReactNode;
}

interface TabProps {
  name: string;
  children?: ReactNode;
  url: string;
  activeTab: string;
  baseClassName: string;
  callback: Function;
  isDisabled?: boolean;
}

export const TabsContext = createContext<{
  baseClassName: string;
  activeTab: string;
  setTab: (name: string) => void;
} | null>(null);

export function TabsPanel({
  tabs,
  baseClassName,
  activeTab,
  callback,
  scrollToTopEnable = true,
}: TabsPanelProps) {
  const [content, setContent] = useState<ReactNode>();
  const tabRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="tab-container" ref={tabRef}>
      <Tabs baseClassName={baseClassName}>
        {tabs.map((tab) => (
          <Tab
            isDisabled={tab.isDisabled}
            key={tab.name}
            name={tab.name}
            url={tab.url}
            activeTab={activeTab}
            baseClassName={baseClassName}
            callback={callback}
          >
            {tab.name}
            {tab.headerAction && tab.headerAction}
          </Tab>
        ))}
      </Tabs>
      <div className="tab-wrapper">{content}</div>
    </div>
  );
}

export function Tabs({ baseClassName, children, ...rest }: TabsProps) {
  return (
    <>
      <div className={`tab-header ${baseClassName}-tabs`} {...rest}>
        {children}
      </div>
    </>
  );
}

export function Tab({
  name,
  children,
  url,
  activeTab,
  baseClassName,
  callback,
  isDisabled,
}: TabProps) {
  const pathname = location.pathname.split("?")[0];
  const activeClass = pathname.startsWith(url) ? " active" : "";
  return (
    <div
      className={`tabContainer ${pathname.startsWith(url) ? "activeTab" : ""}`}
    >
      <ButtonLink
        disabled={isDisabled}
        to={url ? url : ""}
        onClick={() => callback(name)}
        variant="tab"
        color="primary"
        className={`${baseClassName}-tab${activeClass}`}
      >
        {children}
      </ButtonLink>
    </div>
  );
}

export function SPTabs({
  tabs,
  baseClassName,
  activeTab,
  callback,
  scrollToTopEnable = true,
}: TabsPanelProps) {
  const [content, setContent] = useState<ReactNode>();
  const tabRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="tab-container" ref={tabRef}>
      <Tabs baseClassName={baseClassName}>
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            name={tab.name}
            url={tab.url}
            activeTab={activeTab}
            baseClassName={baseClassName}
            callback={callback}
          >
            {tab.name}
            {tab.headerAction && tab.headerAction}
          </Tab>
        ))}
      </Tabs>
      <div className="tab-wrapper">{content}</div>
    </div>
  );
}
